import React,{useState,useEffect} from 'react';
import {Storage,Auth} from "aws-amplify";
import {
  Select,FormControl,MenuItem,InputBase,
  ListItem,List,ListItemText,Divider,Icon,
  Paper,IconButton, Grid, CircularProgress
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
//redux stuff
import {useDispatch,useSelector} from 'react-redux' //get from redux 
import {changeFascia} from '../../features/fascia';
import {rxExhibitor} from "../../features/exhibitor"; //set redux

const useStyles = makeStyles({
  warn: {
      backgroundColor: 'red'
    },
  booker: {
    backgroundColor: '#bbdefb'
  },
  brp: {
    backgroundColor: '#dcedc8'
  },
  h1: {
    backgroundColor: '#bbdefb'
  },
  h2: {
    backgroundColor: '#EF9A9A'
  },
  h3: {
    backgroundColor: '#FFB74D'
  },
  m3: {
    backgroundColor: '#FFB74D'
  },
  h4: {
    backgroundColor: '#CFD8DC'
  },
  h5: {
    backgroundColor: '#BDBDBD'
  }
  });



const ListControl = (props)=>{
    const [tableData, 
      setTableData] = useState([]);
    const [exhibitorList, 
      setExhibitorList] = useState([]);
    const [searchText, 
        setSearchText] = useState('');
    const [loading,
    setLoading] = useState(true)
    const [loggedInUser,
    setLoggedInUser] = useState('')

    const classes = useStyles();

    const dispatch = useDispatch();

    const exhibitor= useSelector((state)=>state.exhibitor.value);

    const handleExhibitorChange = (event) => {
      //setExhibitor(event.target.value);
      dispatch(rxExhibitor(event.target.value)); //set the exhibitor
    };

    
    const GetJSON = async (props) => {
      try {
          // extract file contents
          //https://docs.amplify.aws/lib/storage/download/q/platform/js#get+
          setLoading(true)
          const retval = await Storage.get(props, {download: true, cacheControl: 'no-cache'})
          var json = await new Response(retval.Body).json();
          //alert('got data:'+json.length)
          setTableData(json)
          var lookup={}
          var unique_exhibitors = []
          //now get the list of exhibitors
          json.map(r => {
            if (!(r.user_name in lookup)){
                lookup[r.user_name] =1;
                unique_exhibitors.push(r.user_name)
            }
            return null
          })

          setExhibitorList(unique_exhibitors.sort())
          setLoading(false)
          return json;
      } catch (e) {
          console.log("error getting json:"+e);
        return {retval:"error getting json"};
      }
    }
    
  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleChange = (e)=>{
    setSearchText('')
    handleExhibitorChange(e)
  }

  /**
   * Set the redux value of fascia to show in the ZappBar heading
   * @param {*} title 
   */
  const handleFascia = (title) => {
    dispatch(changeFascia(title));
  };

  /**
   * Gets the current authenticated users credentials, grab the appropriate json file and set the fascia display name 
   */
  const GetUserDetail = async() => {
    const user = await Auth.currentAuthenticatedUser();
    setLoggedInUser(user.username)
    switch (user.username){
      case "admin":
        handleFascia('Admin')
        GetJSON('')
        break;
      case "booker":
        handleFascia('Booker')
        GetJSON('show-data/Fascia-A.json')
        break;
      case "brp":
        handleFascia('BRP')
        GetJSON('show-data/Fascia-B.json')
        break;
      case "exhibitor":
        handleFascia('Exhibitor')
        GetJSON('show-data/Fascia-ALL.json')
      break;
      default:
    } 
  }
    const getFasciaClass=(fascia)=>{
      let className =''
      let fasciaName = ''
      switch(fascia.toUpperCase()){
        case 'A':
          className = classes.booker
          fasciaName = 'Booker'
          break;
        case 'B':
          className = classes.brp
          fasciaName = 'BRP'
          break;
        case 'H1':
          className = classes.h1
          fasciaName = 'Hall 1'
          break;
        case 'H2':
          className = classes.h2
          fasciaName = 'Hall 2'
          break;
        case 'H3':
          className = classes.h3
          fasciaName = 'Hall 3'
          break;
        case 'M3':
          className = classes.m3
          fasciaName = 'Mezz 3'
          break;
        case 'H4':
          className = classes.h4
          fasciaName = 'Hall 4'
          break;
        case 'H5':
          className = classes.h5
          fasciaName = 'Hall 5'
          break;
        default:

      }
      return {className:className,fasciaName:fasciaName}
    }

    //get the json data
  useEffect(() => {
    GetUserDetail();
  }, [])/* eslint-disable-line react-hooks/exhaustive-deps*/

    return (  
    (loading)
      ?
      <Grid container align = "center" justifyContent = "center" alignItems = "center" >
        <CircularProgress color="secondary"/>
      </Grid>
    :
    <>
    <FormControl fullWidth>
      <Select
        id="exhibitor_select"
        value={exhibitor}
        label="Exhibitor"
        onChange={handleChange}
        style={{margin:'10px'}}
        displayEmpty={true}
      >
        <MenuItem value=''>All Exhibitors</MenuItem>
      {
        exhibitorList.map(r=>
          <MenuItem value={r}>
            <Grid container >
              <Grid item xs={12}>
                {r.toUpperCase()}
              </Grid> 
            </Grid>
          </MenuItem>  
        ) 
      }
      </Select>
      </FormControl>
      <Paper
          component="form"
          sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
        >
          <IconButton  sx={{ p: '10px' }} aria-label="search">
            <Icon>search</Icon>
          </IconButton>
          <InputBase
            id='item_search'
            sx={{ ml: 1, flex: 1 }}
            placeholder="Item Search..."
            inputProps={{ 'aria-label': 'search items' }}
            value={searchText} 
            onChange={handleSearchTextChange}
          />
      </Paper>
      <List id='items_found'>
        {tableData
        .filter(r=>r.user_name.toUpperCase()===exhibitor.toUpperCase()||exhibitor.toUpperCase()==='')
        .filter(r=>r.descrip.toUpperCase().indexOf(searchText.toUpperCase())>-1)
        .map((r,i)=>
        (i<2000)
        ?
          <div key={'div_key'+i}>
            <ListItem 
            key={'item_'+i} 
            className={
              (loggedInUser==='exhibitor') ? 
              getFasciaClass(r.fascia).className
              : null }
            >
              <ListItemText key={'txt_'+i} 
              secondary={
                (loggedInUser==='exhibitor')?
                getFasciaClass(r.fascia).fasciaName+': '+r.user_name 
                : r.user_name} 
              primary={r.descrip} 
              />
              {'£'+(Math.round(r.price * 100) / 100).toFixed(2)}
            </ListItem>
            <Divider />
          </div>
          :
          (i===2000)?
          <div key={'div_key'+i}>
            <ListItem key={'item_'+i+1}>
            <ListItemText key={'txt'+i+1} id={i} 
            secondary={'Please refine list by choosing an exhibitor or using Item Search..'} 
            primary={'Max Items Shown'} 
            />
            
            </ListItem>
            <Divider />
            </div>
          :
          null
        )}
        
      </List>
    </>
    )
}
export default ListControl